export function getParameterFromQueryString(
  querystring: string,
  paramName: string
): string {
  paramName = paramName.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + paramName + "(=([^&#]*)|&|#|$)", "i"),
    results = regex.exec(querystring);
  if (!results) return "";
  if (!results[2]) return "";
  return decodeURIComponent(results[2]);
}
